import { render, staticRenderFns } from "./GeneralJournalEntry.vue?vue&type=template&id=90d8a25e"
import script from "./GeneralJournalEntry.vue?vue&type=script&lang=js"
export * from "./GeneralJournalEntry.vue?vue&type=script&lang=js"
import style0 from "./GeneralJournalEntry.vue?vue&type=style&index=0&id=90d8a25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports